
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  height: 100%;
}

.entire-link-wrapper {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

.card {
  display: grid;
  height: 100%;
  justify-content: space-between;
  border-radius: 0.5rem;
  padding: 1rem;
  --tw-shadow: 0px 8px 32px rgba(0, 0, 0, 0.06);
  --tw-shadow-colored: 0px 8px 32px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

@media (min-width: 768px) {

  .card {
    padding: 1.5rem;
  }
}

.image-wrapper {
  margin-right: 1.5rem;
  display: none;
}

@media (min-width: 1440px) {

  .image-wrapper {
    display: block;
  }
}

.image-wrapper{
  max-width:175px;
}

.tag-wrapper {
  display: none;
}

@media (min-width: 768px) {

  .tag-wrapper {
    display: block;
  }
}

.title {
  color: var(--blue-responsible-darken-2);
}

.summary-wrapper {
  color: var(--gray-professional-lighten-1);
}

@media (min-width: 1024px) {

  .summary-wrapper {
    margin-top: 1rem;
  }
}

@media (min-width: 1440px) {

  .summary-wrapper {
    margin-top: 0px;
  }
}

.summary-wrapper{
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-line-clamp:2;
  -webkit-box-orient:vertical;
}

.tag-wrapper, .title, .summary-wrapper, .authors {
  margin-bottom: 1rem;
}

.button-wrapper {
  display: none;
}

@media (min-width: 768px) {

  .button-wrapper {
    display: block;
  }
}

@media screen and (min-width: 768px){
  .card{
    grid-template-columns:auto 1fr;
    grid-template-rows:1fr auto;
  }
  .image-wrapper{
    grid-column:1;
  }
  .content-top-wrapper{
    grid-column:2;
  }
  .content-bottom-wrapper{
    grid-column:1 / 3;
    grid-row:2 / 3;
  }
}

@media screen and (min-width: 1444px){
  .card{
    grid-template-columns:auto auto;
    grid-auto-flow:column;
  }
  .image-wrapper{
    grid-column:1;
    grid-row:span 6;
  }
  .content-top-wrapper{
    grid-column:2;
  }
  .content-bottom-wrapper{
    grid-column:2;
  }
}

.outline-bg-light-blue {
  background-color: var(--blue-responsible-lighten-5);
}

.outline-bg-blue {
  background-color: var(--blue-responsible-lighten-4);
}

.outline-bg-gray {
  background-color: var(--gray-professional-lighten-4);
}

.outline-bg-green {
  background-color: var(--green-guarantee-lighten-4);
}

.outline-bg-white {
  background-color: var(--neutral-white);
}

.outline-bg-transparent {
  background-color: var(--neutral-transparent);
}
`;